export class Config {
    static shippers = [
        "DHL", "DPD", "GLS", "UPS"
    ];
}